/* eslint-disable camelcase */
import MainLoader from 'ageas-react-component-loader'
import { useEffect } from 'react'

import { MIN_PRICE } from '../../constants/minPrice'
import { PRICE_TYPE } from '../../constants/priceType'
import { QUOTATION_STATUS_CODE } from '../../constants/quotationStatusCode'
import { MainContainer } from '../../GlobalStyles'
import { useGetQuotation } from '../../hooks/api/getQuotation/useGetQuotation'
import { useGetQuotationPayload } from '../../hooks/api/getQuotation/useGetQuotationPayload'
import { useIssueCost } from '../../hooks/useIssueCost'
import { useReferrals } from '../../hooks/useReferrals'
import { t } from '../../i18n'
import { useAnimalStore } from '../../Stores/animalStore'
import { useReportStore } from '../../Stores/reportStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useCreateProposalStore } from '../../Stores/useCreateProposalStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useGetQuotationStore } from '../../Stores/useGetQuotationStore'
import { useRequestQuotationStore } from '../../Stores/useRequestQuotationStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { currencyFormatter } from '../../utils/currencyFormatter'
import { InfoIcon, Relatorio } from '../Icons'
import { Tooltip } from '../Tooltip'
import {
  AdvanceButton,
  AdvanceButtonContainer,
  FooterBarContainer,
  FooterBarElement,
  InfoIconContainer,
  Left,
  NrOfSafeAnimals,
  PaymentContainer,
  PaymentValue,
  ReportContainer,
  ReportText,
  Right,
  SafeAnimals,
} from './styles'

type Props = {
  isLoading?: boolean
  isDisabled?: boolean
  setShowSimulationReport: (value: boolean) => void
  onActionClick: () => void
  onRecalculateActionClick?: () => void
}

// const currentDate = moment()
// const elementPortal = document.getElementsByTagName('body')?.[0]

export const FooterBar = ({
  isLoading,
  isDisabled,
  setShowSimulationReport,
  onActionClick,
  onRecalculateActionClick,
}: Props) => {
  // const [showRequestAuth, setShowRequestAuth] = useState(false)
  const {
    totalPricesObjects,
    typeOfPrice,
    // hasGenerateProposal,
    isRecalculate,
  } = useSimulatorStore()
  const { animalsList } = useAnimalStore()
  const { isReportGeneratedEnabled, setIsReportGeneratedEnabled } =
    useReportStore()
  const { isReferralWarning, enabledRunPetisRequest } =
    useRunPetisSimulationStore()
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { requestQuotation } = useRequestQuotationStore()
  const { getIssueCostValue } = useIssueCost()
  const { handleDisableReportSimplified } = useReferrals()
  const { disabledStepsByResume, isQuotationResume } = useResumeStore()
  const enableReportSimplified = handleDisableReportSimplified()
  const { hasCreatedProposal } = useCreateProposalStore()
  const { getQuotation } = useGetQuotationStore()

  const { mutate: mutateGetQuotation, isLoading: isLoadingGetQuotation } =
    useGetQuotation()
  const payloadGetQuotation = useGetQuotationPayload()

  // const hasAnimalBetweenEightAndTen =
  //   animalsList.filter((animal) => {
  //     const yearDifference = currentDate.diff(animal.birthDate, 'years')
  //     if (yearDifference >= 8 && yearDifference <= 10) {
  //       return animal
  //     } else {
  //       return null
  //     }
  //   }).length > 0

  const totalPriceResult = () => {
    let total = 0

    for (const key in totalPricesObjects) {
      if (typeof totalPricesObjects[key] === 'number') {
        total += totalPricesObjects[key]
      }
    }

    return total
  }

  useEffect(() => {
    if (
      Boolean(requestQuotation?.quotationId) &&
      !isQuotationResume &&
      !enabledRunPetisRequest
    ) {
      mutateGetQuotation(payloadGetQuotation)
    }
  }, [isQuotationResume, requestQuotation?.quotationId, enabledRunPetisRequest])

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.paddingBottom = '90px'

    return () => {
      document.getElementsByTagName('body')[0].style.paddingBottom = '0'
    }
  }, [])

  return (
    <>
      <MainLoader show={isLoadingGetQuotation} />
      <FooterBarContainer>
        <MainContainer>
          <FooterBarElement>
            <Left>
              <SafeAnimals>
                <NrOfSafeAnimals>
                  {animalsList.length}{' '}
                  {t('pages.step2.footerbar.animal', {
                    count: animalsList.length,
                  })}{' '}
                  {t('pages.step2.footerbar.secure', {
                    count: animalsList.length,
                  })}
                </NrOfSafeAnimals>
                {enableReportSimplified && (
                  <ReportContainer
                    disabled={
                      isLoading ||
                      !isReportGeneratedEnabled ||
                      isReferralWarning ||
                      disabledStepsByResume.step2 ||
                      hasCreatedProposal ||
                      (getQuotation !== null &&
                        getQuotation?.policyQuotation?.status !==
                          QUOTATION_STATUS_CODE.AC)
                    }
                    onClick={() => setShowSimulationReport(true)}
                  >
                    <Relatorio color="white" size={24} />
                    <ReportText>
                      {t('pages.step2.footerbar.generateReport')}
                    </ReportText>
                  </ReportContainer>
                )}
              </SafeAnimals>
            </Left>
            <Right>
              <PaymentContainer>
                {!isRecalculate && (
                  <>
                    <PaymentValue>
                      {totalPriceResult() <= MIN_PRICE ? (
                        <span>--</span>
                      ) : (
                        <>
                          {currencyFormatter(totalPriceResult())} €/
                          {PRICE_TYPE[typeOfPrice as never]}
                        </>
                      )}
                    </PaymentValue>
                    <InfoIconContainer>
                      <Tooltip
                        maxWidth="300px"
                        id="footerInfo"
                        text={t('pages.step2.footerbar.toolTip', {
                          value: getIssueCostValue() || '',
                        })}
                      >
                        <InfoIcon color="white" size={24} />
                      </Tooltip>
                    </InfoIconContainer>
                  </>
                )}
              </PaymentContainer>
              {/* <QuotationButton>
                {!Boolean(requestQuotation?.quotationId) &&
                  !hasGenerateProposal &&
                  !hasAnimalBetweenEightAndTen &&
                  !disabledStepsByResume.step5 && (
                    <QuotationButtonContainer
                      type="button"
                      disabled={isLoading || isRecalculate}
                      onClick={() => setShowRequestAuth(true)}
                    >
                      {t('pages.step5.sendForQuotationBtn')}
                    </QuotationButtonContainer>
                  )}
              </QuotationButton> */}
              {isRecalculate && (
                <AdvanceButtonContainer>
                  <AdvanceButton
                    type="button"
                    disabled={isLoading || isDisabled}
                    onClick={() => {
                      onRecalculateActionClick && onRecalculateActionClick()
                      setIsReportGeneratedEnabled(true)
                    }}
                  >
                    {t('pages.step2.footerbar.recalculate')}
                  </AdvanceButton>
                </AdvanceButtonContainer>
              )}
              {!isRecalculate && (
                <AdvanceButtonContainer>
                  <AdvanceButton
                    type="button"
                    disabled={
                      isLoading ||
                      isDisabled ||
                      isGenerateProposalDocuments ||
                      disabledStepsByResume.step2 ||
                      totalPriceResult() === 0 ||
                      totalPriceResult() <= MIN_PRICE
                      // || (getQuotation?.policyQuotation?.status !==
                      //   QUOTATION_STATUS_CODE.AC &&
                      //   getQuotation?.policyQuotation?.status !== undefined) ||
                      // isReferralWarning
                    }
                    onClick={onActionClick}
                  >
                    {t('pages.step2.footerbar.advance')}
                  </AdvanceButton>
                </AdvanceButtonContainer>
              )}
            </Right>
          </FooterBarElement>
        </MainContainer>
      </FooterBarContainer>
      {/* {createPortal(
        <RequestAuthorization
          isVisible={showRequestAuth}
          closeAction={() => setShowRequestAuth(false)}
        />,
        elementPortal!,
      )} */}
    </>
  )
}
